<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Library"
                   :links="[{title:'Home', url:'/'},{title:'Library'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="1"></sidebar>
        </section>
        <section class="content">
          <div class="flex heading-black1 justify-center uppercase font-serif">Central Library</div>
          <blockquote class="mt-8 text-gray-600 text-justify font-medium">
            <p>Institute has set up the Library facility at the department level as well as at the central level named
              as Department Library and Central Library respectively. The department Library includes set of books only.
              The major library resources are available at the Central Library. The Central Library has rich collection
              of Text Books, Reference Books, Handbooks in a form of hard copies and e-books. The hard copies available
              in the Library are 20156 volumes. The Institute has a Membership of NDL, which provides the online access
              to various learning resources such as audiovisual and text resources. The Library has subscribed 104 Print
              Journals. In addition to this the Institute has subscribed for DELNET which provides access to 10839 free
              E-books in 709 categories and 860 e-journals for Engineering and Technology. Daily Newspapers and
              Periodicals are available in the Library.</p>

            <p>The Central Library has a separate Digital Library equipped with 20 nos. of computers with internet and
              intranet facilities. For the smooth functioning of Library and for the ease of the students a computer
              interface has been provided. It is equipped with NPTELs audio- video lectures, and CDs of Engineering
              courses.</p>

            <p>The Central Library of Institute has provision of spacious reading room for 150 students. It offers very
              peaceful ambiance for students</p>
          </blockquote>
        </section>
      </div>
      <programmes></programmes>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/library/Sidebar";
import Programmes from "@/views/about/Programmes";

export default {
  name: "About",
  components: {
    Programmes,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {div: null}
  }
}
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 0.6rem;
}
</style>
